import { Icon } from "@fluentui/react";

type StarRatingProps = {
    rating: number;
    maxRating: number;
    color: string;
}

export default function DisplayStarRatingView({ rating, maxRating, color }: StarRatingProps) {
    const filledStars = Math.min(rating, maxRating);
    const remainStarts = maxRating - rating;

    return <span className="rating">
        {Array(filledStars).fill(0).map((value: number) => {
            return <Icon iconName="FavoriteStarFill" />;
        })}

        {remainStarts > 0 && Array(remainStarts).fill(0).map((value: number) => {
            return <Icon iconName="FavoriteStar" />;
        })}
    </span>
}